import React from 'react';

import { Skeleton } from '@material-ui/lab';

import BaseSkeleton from '../BaseSkeleton';
import Card from '../../../Card';
import Divider from '../../../Divider';

import { PaymentOptionsListSkeletonProps } from './PaymentOptionsListSkeleton.types';

const PaymentOptionsListSkeleton: React.FC<PaymentOptionsListSkeletonProps> = ({ size }) => {
  return (
    <Card className="flex flex-column py4">
      {Array(size)
        .fill(0)
        .map((_el, ind) => (
          <>
            <div key={ind} className="flex flex-justify ml2">
              <div className="flex flex-row">
                <Skeleton
                  variant="circle"
                  width={24}
                  height={24}
                  className="mr2 mt2"
                />
                <div className="flex flex-column ml2">
                  <BaseSkeleton width={100} className="mb2" />
                  <BaseSkeleton width={120} className="mb2" />
                </div>
              </div>
              <BaseSkeleton width={80} className="mr2"/>
            </div>
            {ind !== size - 1 && <Divider className="mb3" />}
          </>
        ))}
    </Card>
  );
};

export default PaymentOptionsListSkeleton;
export { PaymentOptionsListSkeletonProps };
